"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
// Set dataVersion that will be sent to the API to determine which shape of data to return
const dataVersion = 1;
const params = new URLSearchParams(window.location.search);
// use specific config / fee id
const preview = params.get('preview') || undefined;
class ApiService {
    constructor() {
        this.onRequest = (config) => {
            // Do something before request is sent
            const { method, data } = config;
            if (method === 'post') {
                config.data = Object.assign({ 
                    // Adding the UI version info to the data.
                    uiVersion: process.env.REACT_APP_UI_VERSION, //string, use the version as set in package.json
                    dataVersion }, data);
            }
            return config;
        };
        this.onRequestError = (error) => {
            // Do something with request error
            return Promise.reject(error);
        };
        this.axiosInstance = axios_1.default.create({
            baseURL: process.env.REACT_APP_API_URL,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        });
        this.axiosInstance.interceptors.request.use(this.onRequest, this.onRequestError);
    }
    getAxiosInstance() {
        return this.axiosInstance;
    }
    getSchoolConfig(schoolId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const configUrl = `schools/${schoolId}/config`;
                const response = yield this.axiosInstance.get(configUrl, {
                    params: { preview },
                });
                return response.data;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }
            catch (error) {
                yield this.onError(error);
            }
        });
    }
    onError(error) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            throw ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data.message) || error.message;
        });
    }
    postEnquiry(data) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                const enquiryUrl = '/enquiries';
                const response = yield this.axiosInstance.post(enquiryUrl, data, {
                    params: { preview },
                });
                return (_a = response.data) === null || _a === void 0 ? void 0 : _a.data;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }
            catch (error) {
                yield this.onError(error);
            }
        });
    }
    delete(url) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.axiosInstance.delete(url);
            }
            catch (e) {
                return { error: 'Problem saving to the API' };
            }
        });
    }
}
exports.default = new ApiService();
